import * as angular from "angular";

import "./streetview.scss";

interface IStreetViewDirectiveScope extends angular.IScope {
    heading: number;
    latitude: number;
    longitude: number;
    availableCheck: Function;
    svp: google.maps.StreetViewPanorama;
}

export class StreetViewDirective implements angular.IDirective {

    restrict = "E";
    scope = {
        heading: "=",
        latitude: "=",
        longitude: "=",
        availableCheck: "&"
    };

    public link: (scope: IStreetViewDirectiveScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) => void;

    constructor(
        private $q: angular.IQService
    ) {
        StreetViewDirective.prototype.link = ($scope: IStreetViewDirectiveScope, $element: angular.IAugmentedJQuery, attrs: ng.IAttributes) => {

            $scope.$watchGroup(["latitude", "longitude", "heading"], () => {
                this.showStreetView($scope, $element);;
            });

            $scope.$on("$destroy", () => {
            });
        }
    }

    private showStreetView($scope: IStreetViewDirectiveScope, $element: angular.IAugmentedJQuery) {
        var options = this.createOptions($scope);

        this.getStreetViewStatus(options.position)
            .then(status => {
                var available = status === google.maps.StreetViewStatus.OK;
                if ($scope.availableCheck) {
                    $scope.availableCheck(available);
                }

                if (available) {
                    $element.removeClass("street-view-error");

                    if (!$scope.svp) {
                        $scope.svp = this.createStreetViewPanorama($element[0], options, null);
                    }

                    this.setStreetViewPosition($scope.svp, options);
                } else {
                    $element.addClass("street-view-error");
                    if ($element.find(".street-view-error-message").length === 0) {
                        $element.append("<div class='street-view-error-message'>Street View unavailable at this location</div>");
                    }
                }
            });
    }

    private createOptions($scope: IStreetViewDirectiveScope): google.maps.StreetViewPanoramaOptions {
        return {
            position: { lat: $scope.latitude, lng: $scope.longitude },
            pov: {
                heading: $scope.heading,
                pitch: 0
            }
        };
    }

    static factory(): angular.IDirectiveFactory {
        const directive = ($q) => new StreetViewDirective($q);

        directive.$inject = ["$q"];

        return directive;
    }

    private createStreetViewPanorama(element: Element, options: google.maps.StreetViewPanoramaOptions, events): google.maps.StreetViewPanorama {

        var defaultOptions: google.maps.StreetViewPanoramaOptions = {
            pov: {
                heading: 0,
                pitch: 0
            },
            linksControl: false,
            panControl: true,
            zoomControl: true,
            zoomControlOptions: {
                style: google.maps.ZoomControlStyle.SMALL
            },
            fullscreenControl: false,
            enableCloseButton: false
        };

        if (options) {
            angular.extend(defaultOptions, options);
        }

        var svp = new google.maps.StreetViewPanorama(element, defaultOptions);

        return svp;
    };

    setStreetViewPosition(svp: google.maps.StreetViewPanorama, options: google.maps.StreetViewPanoramaOptions) {
        setTimeout(() => {
            // Required for display in off screen scenarios
            svp.setVisible(true);
            svp.setPov(options.pov);
            svp.setZoom(1); // fixes fish eye distortion
            svp.setPosition(options.position);

            google.maps.event.trigger(svp, "resize");
        });
    }

    private getStreetViewStatus(position: google.maps.LatLng | google.maps.LatLngLiteral): angular.IPromise<google.maps.StreetViewStatus> {
        var defer = this.$q.defer<google.maps.StreetViewStatus>();

        const svService = new google.maps.StreetViewService;

        svService.getPanoramaByLocation(position, 30, (streetViewPanoramaData: google.maps.StreetViewPanoramaData, streetViewStatus: google.maps.StreetViewStatus) => {
            defer.resolve(streetViewStatus);
        });

        return defer.promise;
    }
}
